import { WindowMock } from "./WindowMock";
import { APP_ICONS } from "./appIcons";
import styles from "./Hero.module.css";

/**
 * Hero — giant ATLAS DESK display type set against the suite's teal
 * bands wallpaper, anchored by floating Atlas windows. The wallpaper
 * drifts on a constant CSS keyframe (no scroll modulation, no parallax)
 * so the surface reads as quietly alive without reacting to anything.
 */
export function Hero() {
  return (
    <section className={styles.hero} aria-label="Atlas Desk">
      <div className={styles.wallpaper} aria-hidden />
      <div className={styles.grain} aria-hidden />

      <div className={`atlasContainer ${styles.inner}`}>
        <div className={styles.copy}>
          <h1 className={styles.title}>
            <span className={styles.titleLine}>ATLAS</span>
            <span className={styles.titleLine}>DESK</span>
          </h1>
          <p className={styles.lede}>
            Tiny tools. One calm environment.
            <br />
            A lightweight desktop for people who miss when software felt
            understandable.
          </p>
          <div className={styles.actions}>
            <a className={styles.primary} href="#download">
              Download <span aria-hidden>→</span>
            </a>
            <a
              className={styles.preview}
              href="/preview/"
              target="_blank"
              rel="noopener"
              title="Open the live Atlas Desk preview in a new tab"
            >
              <span className={styles.previewDot} aria-hidden />
              Try in browser
            </a>
          </div>
          <a className={styles.secondary} href="#philosophy">
            Read the philosophy →
          </a>
        </div>

        <div className={styles.stage}>
          {/* Each window is wrapped in a "breath" element that handles
              positioning + slow ambient drift. The WindowMock itself
              keeps its own hover lift; the wrapper's transform composes
              with the inner element, so the two never fight. */}
          <div className={styles.notesBreath}>
            <WindowMock title="NOTES" iconSvg={APP_ICONS.notes}>
              <p className={styles.stickyHeading}>
                Welcome back to personal computing.
              </p>
              <p className={styles.stickyBody}>
                Software should do one thing well. Atlas Desk is the rest of
                the desktop — quiet, modular, yours.
              </p>
              <p className={styles.stickySign}>— Atlas</p>
            </WindowMock>
          </div>

          {/* Loose sticky note to the right of the Notes window. Mirrors
              the Stickies app's visual: mustard body, dark header strip
              with the STICKY label, 2px ink border, hard offset shadow,
              slight rotation so it looks hand-placed. */}
          <div className={styles.stickyBreath}>
            <div className={styles.sticky}>
              <div className={styles.stickyHeader}>STICKY</div>
              <div className={styles.stickyContent}>
                <p className={styles.stickyLine}>Atlas Desk launch</p>
                <p className={styles.stickyLine}>— wallpaper drift?</p>
                <p className={styles.stickyLine}>— layouts demo</p>
                <p className={styles.stickyLine}>— ship Friday</p>
              </div>
            </div>
          </div>

          <div className={styles.musicBreath}>
            <WindowMock
              title="MUSIC"
              iconSvg={APP_ICONS.music}
              bodyPadding="flush"
            >
              <div className={styles.miniMusic}>
                <div className={styles.miniMusicCover} />
                <div className={styles.miniMusicMeta}>
                  <div className={styles.miniMusicTitle}>
                    Late-night calm computing
                  </div>
                  <div className={styles.miniMusicArtist}>Atlas Sessions</div>
                </div>
                <div className={styles.miniMusicScrubber}>
                  <span className={styles.miniMusicProgress} />
                </div>
              </div>
            </WindowMock>
          </div>
        </div>
      </div>

      <div className={styles.scrollHint} aria-hidden>
        <span>SCROLL</span>
        <span className={styles.scrollHintLine} />
      </div>
    </section>
  );
}
